import $ from 'jquery';

import LinkedOptions from './LinkedOptions';
import ThemeUtils from './ThemeUtils';

export default class VariantHelper {
  constructor(options) {
    const defaultOptions = {
      $addToCartButton: null, // Set with object of add to cart button
      $priceFields: null, // Set with object containing price(s)
      $productForm: null, // Set with object containing the `data-product-form` attribute
      $selector: null, // Set with an object that contains select/input[type=checkbox] objects
      type: 'select', // Or radio
      productJSON: null, // Set with product JSON information
      productSettings: null, // Set with JSON containing product message strings and/or display options
    };

    this.themeUtils = ThemeUtils;
    this.callbacks = [];

    this.options = this.themeUtils.extend(defaultOptions, options);
    this.$body = $(document.body);
    this.linkedOptions = null;
    this.enableHistory = false;
    this.$masterSelect = this.options.$productForm.find(`#product-select-${this.options.formID}`);
    this.$smartPaymentButtons = this.options.$productForm.find('.shopify-payment-button');

    // Disabled history state updating in the TE
    const isShopify = window.Shopify && window.Shopify.preview_host;

    if (
      window.history
      && window.history.replaceState
      && this.options.productSettings.enableHistory
      && !isShopify
    ) {
      this.enableHistory = true;
    }

    this._bindEvents();

    if (this.options.type === 'select') {
      $(this.options.$selector).each((index, element) => {
        this._setSelectLabel(null, $(element));
      });
    }

    if (this.options.productSettings.linkedOptions) {
      this.linkedOptions = new LinkedOptions(this.options);
    }
  }

  onVariantChange(callback) {
    if (this.callbacks.indexOf(callback) >= 0) {
      return;
    }

    this.callbacks.push(callback);
  }

  offVariantChange(callback) {
    if (this.callbacks.indexOf(callback) === -1) {
      return;
    }

    this.callbacks.splice(this.callbacks.indexOf(callback));
  }

  getCurrentVariant() {
    return this._getVariantFromOptions(this._getCurrentOptions());
  }

  _bindEvents() {
    this.options.$selector.on('change', event => this._variantChange(event));
  }

  _setSelectLabel(event = null, $target) {
    if ($target == null) { $target = false; }
    if (!$target) {
      $target = $(event.currentTarget);
    }

    const selectedOption = $target.find('option:selected').val();
    $target
      .prev('[data-select-text]')
      .find('[data-selected-option]')
      .text(selectedOption);
  }

  _getCurrentOptions() {
    const productOptions = [];
    let $inputs = this.options.$selector;

    if (this.options.type === 'radio') {
      $inputs = $inputs.filter(':checked');
    }

    $inputs.each((index, element) => productOptions.push($(element).val()));

    return productOptions;
  }

  _getVariantFromOptions(productOptions) {
    if (this.options.productJSON.variants == null) { return; }

    let foundVariant = null;
    this.options.productJSON.variants.forEach((variant) => {
      let productOption = productOptions[0];
      for (let i = 1; i < productOptions.length; i++) {
        productOption += ` / ${productOptions[i]}`;
      }

      if (productOption === variant.title) {
        foundVariant = variant;
      }
    });

    return foundVariant;
  }

  _updateMasterSelect(variant) {
    if (variant == null) { return; }

    this.$masterSelect.find(`[data-variant-id=${variant.id}]`).prop('selected', true);
    this.$masterSelect.trigger('change');
  }

  _updatePrice(variant) {
    const { $addToCartButton } = this.options;
    const { $priceFields } = this.options;
    const { productSettings } = this.options;
    const $displayPrice = $priceFields.find('.money:first-child');
    const $originalPrice = $priceFields.find('.original');
    const $amountSaved = $priceFields.find('.saving-result');
    const $priceComparison = $priceFields.find('.product-price-compare');

    if (variant) {
      if (variant.available) {
        $addToCartButton
          .val(productSettings.addToCartText)
          .removeClass('disabled')
          .removeAttr('disabled');
      } else {
        $addToCartButton
          .val(productSettings.soldOutText)
          .addClass('disabled')
          .attr('disabled', 'disabled');
      }

      if (variant.compare_at_price > variant.price) {
        $displayPrice.html(Shopify.formatMoney(variant.price, Theme.moneyFormat));
        $originalPrice.html(Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat));
        $amountSaved.html(Shopify.formatMoney(variant.compare_at_price - variant.price, Theme.moneyFormat));
        $priceComparison.show();
      } else {
        $displayPrice.html(Shopify.formatMoney(variant.price, Theme.moneyFormat));
        $originalPrice.html('');
        $amountSaved.html('');
        $priceComparison.hide();
      }
    } else {
      $addToCartButton
        .val(productSettings.unavailableText)
        .addClass('disabled')
        .attr('disabled', 'disabled');
    }
  }

  _updateImages(variant) {
    if (variant) {
      this.options.productGallery.selectMediaByVariant(variant);
    }
  }

  _updateHistory(variant) {
    if (!this.enableHistory || !variant) { return; }

    const newUrl = [
      window.location.protocol,
      '//',
      window.location.host,
      window.location.pathname,
      '?variant=',
      variant.id,
    ];

    const variantUrl = newUrl.join('');
    window.history.replaceState({ path: variantUrl }, '', variantUrl);
  }

  _updateTaxLine(variant) {
    if (!variant) return;

    this.options.$priceFields.each((i, el) => {
      const taxLine = el.querySelector('[data-tax-line]');

      if (!taxLine) return;

      if (variant.taxable) {
        taxLine.classList.remove('product__tax--hidden');
      } else {
        taxLine.classList.add('product__tax--hidden');
      }
    });
  }

  _updateUnitPrice(variant) {
    if (!variant) return;

    this.options.$priceFields.each((i, el) => {
      const variantFields = {
        unitPrice: el.querySelector('[data-unit-price]'),
        totalQuantity: el.querySelector('[data-total-quantity]'),
        unitPriceAmount: el.querySelector('[data-unit-price-amount]'),
        unitPriceMeasure: el.querySelector('[data-unit-price-measure]'),
      };

      if (variantFields.unitPrice && variant.unit_price_measurement) {
        variantFields.totalQuantity.innerHTML = `${variant.unit_price_measurement.quantity_value}${variant.unit_price_measurement.quantity_unit}`;

        variantFields.unitPriceAmount.innerHTML = Shopify.formatMoney(variant.unit_price, Theme.moneyFormat);
        if (variant.unit_price_measurement.reference_value === 1) {
          variantFields.unitPriceMeasure.innerHTML = variant.unit_price_measurement.reference_unit;
        } else {
          variantFields.unitPriceMeasure.innerHTML = `${variant.unit_price_measurement.reference_value}${variant.unit_price_measurement.reference_unit}`;
        }
        variantFields.unitPrice.classList.remove('product__unit-price--hidden');
      } else if (variantFields.unitPrice) {
        variantFields.unitPrice.classList.add('product__unit-price--hidden');
      }
    });
  }

  _variantChange(event) {
    if (this.options.type === 'select') {
      this._setSelectLabel(event);
    }

    const productOptions = this._getCurrentOptions();
    const variant = this._getVariantFromOptions(productOptions);

    this._updateMasterSelect(variant);
    this._updatePrice(variant);
    this._updateTaxLine(variant);
    this._updateImages(variant);
    this._updateHistory(variant);
    this._updateSmartPaymentButtons(variant);
    this._updateUnitPrice(variant);
    this.callbacks.forEach(callback => callback(variant));
  }

  _updateSmartPaymentButtons(variant) {
    if (variant && variant.available) {
      this.$smartPaymentButtons.slideDown();
    } else {
      this.$smartPaymentButtons.slideUp();
    }
  }

  prepareRemove() {
    this.options.$selector.off('change');

    if (this.linkedOptions) {
      this.linkedOptions.prepareRemove();
    }
  }
}
